import { useState, useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import TableAHSF from "../../../Components/TableAHSF";
import PopupAHSF from "../../../Components/PopupAHSF";
import loadConfig from "../../../Services/Api/ApiServices";
import { DeleteActivitiesForStage } from "../../../Redux/Reducers/ReportStage/ActivitiesForStage";
import ActivitesForStageForm from "./ActivitesForStageForm";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";

const ActivitesForStage = (props) => {
  const [jsonData, setJsonData] = useState({});
  const dispatch = useDispatch();
  const [popUpBodyOPjectDataStatus, setPopUpBodyOPjectDataStatus] =
    useState(false);
  const [activitiesForStageId, setactivitiesForStageId] = useState(null);
  const state = useSelector((state) => {
    return {
      jsonData: state.FetchDataJson.JsonData,
    };
  });
  const ActivitiesForStageUpdate = useSelector(
    (state) => state.ActivitiesForStage.UpdateActivitiesForStage
  );
  console.log(ActivitiesForStageUpdate, "ActivitiesForStageUpdate");

  const ActiveRound = useSelector((state) => state.RoundReducers.ActiveRound);
  const ApplicationInformation = useSelector(
    (state) => state.ApplicationInformationReducers.ApplicationInformation
  );
  const shouldDisableFields = !(
    ActiveRound == ApplicationInformation?.aI_RoundYearId &&
    ApplicationInformation?.sU_ST_MRI_ApplicationStatus?.canEdit &&
    window.location.href.includes("manager") == false
  );
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];
  const RequestAccessor = [
    {
      KeyName: "activitiesName",
      ShowStatus: true,
      NmaeColumn: "الهدف الفرعي",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "achievementDescriptionName",
      ShowStatus: true,
      NmaeColumn: "وصف الانجاز",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "achievementRateName",
      ShowStatus: true,
      NmaeColumn: "نسبة الانجاز",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "challengesName",
      ShowStatus: true,
      NmaeColumn: "التحديات",
      TotalNumber: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "fileAttachmentName",
      ShowStatus: true,
      NmaeColumn: "المرفق",
     notnewAdded: true,
      DropdownFiltration: { keyTextName: "", keyValueName: "" },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
      notnewAdded: true,
       FileCostume: true,
      typeColumn: "file",
    },
  ];

  const M_ApplicationsBtns = [
    // {
    //   Click: async (e) => {
    //     setsubObjectivesId(e.target.value);
    //     console.log(e.target.value, "sssssssssssss");
    //     setPopUpBodyOPjectDataStatus(true);
    //   },
    //   content: "",
    //   className: "bi bi-view-list",

    //   id: "editBtn",
    //   title: "عرض",
    //   ShowStatus: true,
    // },
    {
      Click: async (e) => {
        setactivitiesForStageId(e.target.value);
        console.log(e.target.value, "sssssssssssss");

        setPopUpBodyOPjectDataStatus(true);
      },
      content: "",
      className: "bi bi-pencil-square",

      id: "editBtn",
      title: "عرض",
      ShowStatus: props.iconsEditOrView,
      ShowHideByCanEdit: false,
      caneEditValue: true,
    },
    {
      Click: async (e) => {
        Swal.fire({
          title: state.jsonData.deleteTitlePopUp?.nameAR,
          icon: "error",
          // iconHtml: "؟",
          confirmButtonText: "تأكيد",
          cancelButtonText: "الغاء",
          showCancelButton: true,
          showCloseButton: true,
        }).then(async (res) => {
          if (res.isConfirmed == true) {
            const deleted = await dispatch(
              DeleteActivitiesForStage({ activitiesForStageId: e.target.value })
            );
            if (deleted.payload) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "تم الحذف بنجاح",
                showConfirmButton: false,
                timer: 1500,
                // width: "500px",
              });
              //to refresh table
              dispatch(setRefreshTable());
            }
          }
        });
      },
      content: "",
      className: "bi bi-trash",
      id: "deleteBtn",
      title: "عرض",
      // ShowStatus: !shouldDisableFields,

      ShowStatus: false,
      //   !shouldDisableFields,
    },
  ];

  const getJson = async () => {
    var json = await loadConfig();
    // //console.log(json,"malwk");

    setJsonData(json);
  };
  useEffect(() => {
    setJsonData(getJson());
  }, []);

  const PopupOPjectData = {
    isPopupOpenStatus: true,
    isPopupOpenFunction: () => {},
    componentBody: (
      <div>
        {
          <ActivitesForStageForm
            canEdit="add"
            reportStageId={props.reportStageId}
          />
        }
      </div>
    ),
    title: "الإنجازات العامة",
    maxWidth: "500px",
    maxHeight: "500px",
  };

  const closePopUpBodyOPjectData = () => {
    setPopUpBodyOPjectDataStatus(false);
  };

  const popUpBodyOPjectData = {
    isPopupOpenStatus: popUpBodyOPjectDataStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyOPjectDataStatus(false);
    },
    componentBody: (
      <div>
        <ActivitesForStageForm
          reportStageId={props.reportStageId}
          activitiesForStageId={activitiesForStageId}
          canEdit="edit"
        />
      </div>
    ),
    title: "الإنجازات العامة ",
    maxWidth: "500px",
    maxHeight: "500px",
  };
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [ActivitiesForStageUpdate]);
  console.log(props.disabled, "ssssssdwdddddddddddwdwd");

  return (
    <>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"activitiesForStageId"}
        valueButtonAction={"activitiesForStageId"}
        URL={`api/ActivitiesForStage/GetListActivitiesForStage`}
        UrlBody={{
          reportStageId: props.reportStageId,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={"الإنجازات العامة"}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        // tableBtn={!shouldDisableFields}
        tableBtn={false}
        sortTable={true}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={false}
        checkBoks={props.checkBoks}
        uniqeKeyName={"activitiesForStageId"}
        uniqeKeyNameRedux={"activitiesForStage"}
        nameColumAction=""
        total={false}
        arrayButton={!props.checkBoks ? M_ApplicationsBtns : false}
        ArrayNameDataColum={[]}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            isPopupOpenStatus={popUpBodyOPjectData.isPopupOpenStatus}
            isPopupOpenFunction={popUpBodyOPjectData.isPopupOpenFunction}
            title={popUpBodyOPjectData.title}
            componentBody={popUpBodyOPjectData.componentBody}
            maxWidth={popUpBodyOPjectData.maxWidth}
            maxHeight={popUpBodyOPjectData.maxHeight}
          />
        }
      />
    </>
  );
};
export default ActivitesForStage;
